<template>
  <div class="message error">
    <p class="textmodal">Para {{ text }} tienes que <a class="register" :href="registerUrl">registrarte</a>.
      Si ya estás registrado, <a class="login" v-cursor @click="onLogin">inicia sesión</a>
    </p>
    <i v-cursor class="fa fa-window-close" @click="$emit('click:cancel')"></i>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      text: String,
    },
    computed: {
      ...mapGetters([
        'loginUrl',
        'redirectUrl',
        'registerUrl',
        'isLogged'
      ])
    },
    methods: {
      // Usamos esta función en lugar de un :href="loginUrl" porque usando esta url de redirectUrl
      // una vez logeado, el usuario es redirigido a la página en la que estaba
      // de lo contrario una vez logeado sería llevado a la página principal
      onLogin() {
        fetch(`${this.redirectUrl}?op=saveref`, { method: 'GET' })
          .then(res => {
            // aquí deberíamos comprobar si res.status !== 200 o !res.ok para
            // validar el estado de la respuesta, pero el servicio de api
            // de callback devuelve siempre 404, así que no comprobamos nada.
            window.location.href = this.loginUrl;
          })
          .catch(err => {
            // sólo si err.status === 50x
            console.log(err);
          });
      },
    },
    destroyed() {
      this.$emit('destroy');
    }
  }
</script>

<style>
  .message {
    position: absolute;
  }
</style>
